import { CustomVideoPlayer } from '@/src/shared/components/CustomVideoPlayer';
import { UpgradePlans } from '@/types/subscription';
import { IUser } from '@/types/user';

const defaultUser: Partial<IUser> = {
  id: 237177,
  subscription: UpgradePlans.platinum,
};

export const Video = () => {
  return (
    <CustomVideoPlayer
      video={
        {
          video_path:
            'https://dofimomuk6s4.cloudfront.net/files/try-roomvu-insurance-video.mp4',
          video_template: 0,
          video_file_type: 'square',
          muted: true,
        } as any
      }
      user={defaultUser}
      showPlayer
      showPlayButton
      loop
    />
  );
};
